import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { SET_TYPE, SET_PROFILE_OPEN } from '../../Actions/Sidebar'
import { GET_CURRENT_USER, UPLOAD_PHOTO, REMOVE_PHOTO } from '../../Actions/User'
import MemberOverview from './MemberOverview'
import FriendsOverview from './FriendsOverview'
import FriendsOverviewTheirs from './FriendsOverviewTheirs'
import EditProfile from './EditProfile'
import NewChat from './NewChat'
import ProfileTheirs from './ProfileTheirs'
import { DotsIcon, CrossIcon, AddIcon, RemoveIcon, ZoomIcon } from '../../Svg/Index.js'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Filtered from '../../Containers/Wazzup/Filtered.js'
import ChatPopup from '../../Containers/Wazzup/ChatPopup.js'


class Sidebar extends Component {

    state = {
        subnavOpen: false,
        dialogActive: false,
        tab: 'bio',
        dialogActive: false,
        selectedPhoto: null,
        photoIndex: 0,
        lightboxOpen: false,
        avatarOpen: false
    }

    changeType = (type) => {
        this.props.actions.SET_TYPE(type)
        this.handleSubnavClose();
        this.setTab('bio')
        this.props.actions.GET_CURRENT_USER(this.props.user).then(user => {

        })
    }

    handleSidebarClose = ()=> {
        document.body.classList.remove('sidebar-open')
    }

    handleSubnavOpen = ()=> {
        this.setState({
            subnavOpen: true
        })
    }

    handleSubnavClose = ()=> {
        this.setState({
            subnavOpen: false
        })
    }

    handleLogout = async () => {
        await localStorage.removeItem('@JO:keycode');
        await localStorage.removeItem('@JO:user');
        this.props.history.push('/')
    }

    handleContact = ()=> {
        this.props.actions.SET_PROFILE_OPEN(1);
        this.setState({
            subnavOpen: false
        })
    }

    setTab = (type)=> {
        this.setState({
            tab: type
        })
    }

    handlePhotoUpload = ()=> {
        let file = this.refs.photo.files[0];
        this.props.actions.UPLOAD_PHOTO(file).then((res)=> {
            if(res.status != 200) {
                alert('De afbeelding is te groot of heeft een onjuist bestands-type. Toegestane afbeeldingen zijn JPG en PNG bestanden die kleiner zijn dan 8MB.')
            } else {
                this.props.actions.GET_CURRENT_USER(this.props.user)
            }
        });
    }

    handlePhotoSelection = (photoId)=> {
        this.setState({
            dialogActive: true,
            selectedPhoto: photoId
        })
    }

    handlePhotoRemove = ()=> {
        this.setState({
            dialogActive: false
        })
        this.props.actions.REMOVE_PHOTO(this.state.selectedPhoto).then(()=> {
            this.props.actions.GET_CURRENT_USER(this.props.user)
        });
    }

    handlePostsShow = (id, name)=> {
        this.props.history.push('/loading')
        setTimeout(()=> {
            this.props.history.push({
                pathname: `/wazzup/filtered/${id}`,
                filteredUserName: name
            })
        })
    }

    render() {
        const { user, sidebar, wazzup } = this.props;
        const { photoIndex, lightboxOpen, avatarOpen } = this.state;

        let images = [];
        if(user.photos) {
            user.photos.forEach((item)=> {
                images.push(item.photo.user_photo)
            })
        }

        return (
            <>
                <aside className="c-sidebar">
                    <div className="c-sidebar__controls">
                        <button className="c-bare-btn c-sidebar-edit c-btn--with-icon" onClick={this.handleSubnavOpen}>
                            <DotsIcon />
                        </button>
                        <button className="c-bare-btn c-sidebar-close c-btn--with-icon" onClick={this.handleSidebarClose}>
                            <CrossIcon />
                        </button>
                    </div>
                    <div className="c-user">
                        <figure className="c-user__media" onClick={() => this.setState({ avatarOpen: true })}>
                            <img src={user.avatar.user_avatar} alt=""/>
                        </figure>
                        <span className="c-user__name">{user.display_name}</span>
                        {
                            user.city && (
                                <span className="c-user__city">{user.city}</span>
                            )
                        }

                        <div className="flex-buttons">
                            <button className="c-btn c-btn--primary-alt c-btn--compact-alt" onClick={ () => this.changeType('friends') }>Vrienden ({user.friends.length}) 
                                {
                                    user.friend_requests.length > 0 && (
                                        <span className="c-btn__count">{user.friend_requests.length}</span>
                                    )
                                }
                            </button>
                            <button className="c-btn c-btn--primary-alt c-btn--compact-alt" onClick={ () => this.changeType('all') }>Ledenoverzicht</button>
                        </div>

                        <div className="c-tabs">
                            <div className={`c-tab ${this.state.tab === 'bio' ? 'is-active' : ''}`} onClick={() => this.setTab('bio')}>
                                <svg width="16px" height="14px" viewBox="0 0 16 14" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><path className="svg-element" d="M10,12 L0,12 L0,14 L10,14 L10,12 Z M16,4 L0,4 L0,6 L16,6 L16,4 Z M0,10 L16,10 L16,8 L0,8 L0,10 Z M0,0 L0,2 L16,2 L16,0 L0,0 Z" fill="#BA95F7" fillRule="nonzero"></path></g></svg>
                            </div>
                            <div className={`c-tab ${this.state.tab === 'photos' ? 'is-active' : ''}`} onClick={() => this.setTab('photos')}>
                                <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><path className="svg-element" d="M18,16 L18,2 C18,0.9 17.1,0 16,0 L2,0 C0.9,0 0,0.9 0,2 L0,16 C0,17.1 0.9,18 2,18 L16,18 C17.1,18 18,17.1 18,16 Z M5.5,10.5 L8,13.51 L11.5,9 L16,15 L2,15 L5.5,10.5 Z" fill="#BA95F7" fillRule="nonzero"></path></g></svg>
                            </div>
                            <div className={`c-tab ${this.state.tab === 'posts' ? 'is-active' : ''}`} onClick={() => this.setTab('posts')}>
                                <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><path className="svg-element" d="M16,0 L1.99,0 C0.88,0 0.01,0.89 0.01,2 L0,16 C0,17.1 0.88,18 1.99,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.89 17.1,0 16,0 Z M16,12 L12,12 C12,13.66 10.65,15 9,15 C7.35,15 6,13.66 6,12 L1.99,12 L1.99,2 L16,2 L16,12 Z" fill="#BA95F7" fillRule="nonzero"></path></g></svg>
                            </div>
                        </div>

                        <div className="c-tab-container">

                            {
                                this.state.tab === 'bio' && (

                                    user.bio ? 
                                        <div className="c-user__bio">
                                            <p>
                                                {user.bio.split('\n').map((item, key) => {
                                                    return <span key={key}>{item}<br/></span>
                                                })}
                                            </p>
                                        </div>
                                    :
                                        <>
                                            <div className="c-user__empty">
                                                Nog geen bio<br />
                                                🤐
                                            </div>
                                            <div className="c-tab__bottom-wrapper">
                                                <button className="c-btn c-btn--secondary c-btn--compact" onClick={() => this.changeType('edit_profile')}>
                                                    <span className="c-btn__icon"><AddIcon /></span>Bio toevoegen
                                                </button>
                                            </div>
                                        </>
                                    
                                )
                            }

                            {
                                this.state.tab === 'posts' && (
                                    <Filtered />
                                )
                            }
                            
                            {
                                this.state.tab === 'photos' && (
                                    <div className={`c-user__photos ${user.photos.length ? 'has-photos' : ''}`}>
                                        {
                                            user.photos.length ? 
                                            <div className="c-user__photos-grid">
                                                {
                                                    user.photos && (
                                                        user.photos.map((item, i) =>
                                                            <div key={`photo-${i}`} className="c-user__photo" style={{backgroundImage: `url(${item.photo.user_photo})`}}>
                                                                <div className="c-user__photo-buttons">
                                                                    <div className="c-user__photo-button c-user__photo-remove" onClick={()=>this.handlePhotoSelection(item._id)}>
                                                                        <RemoveIcon />
                                                                    </div>
                                                                    <div className="c-user__photo-button c-user__photo-zoom" onClick={() => this.setState({ lightboxOpen: true, photoIndex: i })}>
                                                                        <ZoomIcon />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    )
                                                }
                                            </div>   
                                        :
                                            <>
                                                <div className="c-user__empty">
                                                    Nog geen foto's
                                                    <br />
                                                    📸
                                                </div>
                                            </>
                                        }
                                        <div className="c-tab__bottom-wrapper">
                                            <label className="c-btn c-btn--secondary c-btn--compact">
                                                <span className="c-btn__icon"><AddIcon /></span><span className="inline-block">Foto toevoegen</span>
                                                <input className="c-user__photo-input" type="file" accept="image/x-png,image/jpeg" id="photo-input" ref="photo" onChange={this.handlePhotoUpload} />
                                            </label>
                                        </div>

                                        {lightboxOpen && (
                                            <Lightbox
                                                mainSrc={images[photoIndex]}
                                                nextSrc={images[(photoIndex + 1) % images.length]}
                                                prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                                                onCloseRequest={() => this.setState({ lightboxOpen: false })}
                                                onMovePrevRequest={() =>
                                                this.setState({
                                                    photoIndex: (photoIndex + images.length - 1) % images.length,
                                                })
                                                }
                                                onMoveNextRequest={() =>
                                                this.setState({
                                                    photoIndex: (photoIndex + 1) % images.length,
                                                })
                                                }
                                            />
                                        )}

                                    </div>
                                )
                            }
                        </div>
                    </div>

                    {
                        this.state.subnavOpen && (
                            <div className="c-sidebar__inner-nav">
                                <div className="c-sidebar__inner-nav__inner">
                                    <button className="c-btn c-btn--primary c-btn--wide c-btn--compact" onClick={() => this.changeType('edit_profile')}>Wijzig profiel</button>
                                    <button className="c-btn c-btn--primary c-btn--wide c-btn--compact" onClick={this.handleContact}>Contact met Jong & Out</button>
                                    <button className="c-btn c-btn--primary c-btn--wide c-btn--compact" onClick={this.handleLogout}>Uitloggen</button>
                                    <button className="c-btn c-btn--secondary c-btn--wide c-btn--compact" onClick={this.handleSubnavClose}>Annuleren</button>
                                </div>
                            </div>
                        )
                    }

                    {avatarOpen && (
                        <Lightbox
                            mainSrc={user.avatar.user_avatar}
                            onCloseRequest={() => this.setState({ avatarOpen: false })}
                        />
                    )}

                    
                    {
                        (sidebar.type === 'all' && sidebar.profile_theirs_open === false) && (
                            <MemberOverview />
                        )
                    }
                    
                    {
                        (sidebar.type === 'edit_profile' && sidebar.profile_theirs_open === false) && (
                            <EditProfile />
                        )
                    }

                    {
                        (sidebar.type === 'friends_theirs') && (
                            <FriendsOverviewTheirs />
                        )
                    }

                    {
                        (sidebar.type === 'friends' && sidebar.profile_theirs_open === false) && (
                            <FriendsOverview />
                        )
                    }

                    {
                        (sidebar.type === 'chats' && sidebar.profile_theirs_open === false) && (
                            <NewChat />
                        )
                    }

                    {
                        sidebar.profile_theirs_open !== false && (
                            <ProfileTheirs />
                        )
                    }

                    {
                        this.state.dialogActive && (
                            <div className="c-dialog">
                                <div className="c-dialog__inner">
                                    <h2>Weet je het zeker?</h2>
                                    <button className="c-btn c-btn--primary" onClick={this.handlePhotoRemove}>Ja, verwijder</button>
                                    <button className="c-btn c-btn--primary" onClick={ () => this.setState({dialogActive: false}) }>Nee, annuleren</button>
                                </div>
                            </div>
                        )
                    }
                </aside>
                {
                    wazzup.chat_popup.id && (
                        <ChatPopup />
                    )
                }
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        sidebar: state.sidebar,
        user: state.user.user,
        wazzup: state.filtered_wazzup,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_TYPE, GET_CURRENT_USER, SET_PROFILE_OPEN, UPLOAD_PHOTO, REMOVE_PHOTO }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar))